export default __webpack_public_path__ + "static/Jake-Januszanis-Resume-11338819bf915fb92731180d5807bb67.pdf";